<template>
	<div>
		<div class="dingdan">
			<el-breadcrumb separator-class="el-icon-arrow-right">
			  <el-breadcrumb-item>个人中心</el-breadcrumb-item>
			  <el-breadcrumb-item>我的钱包</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="fh_button">
				<i class="el-icon-arrow-left"></i>
				<p>返回</p>
			</div>
		</div>
		<div class="MyWallet">
			<div class="MyWalletbox">
				<div class="MyWalletbox1">
					<img src="@/assets/wallqb.png" alt="" srcset="" />
					<div class="MyWalletbox1_1">
						<div class="MyWalletbox1_zong">
							<p>总收益金额(元)</p>
							<span>￥{{user.total_money}}</span>
						</div>
						<div  class="MyWalletbox1_list">
							<div>
								<p>订单收益(元)</p>
								<span>￥{{user.total_order_money}}</span>
							</div>
							<div>
								<p>推广佣金(元)</p>
								<span>￥{{user.total_brokerage_money}}</span>
							</div>
							<div>
								<p>评审金额(元)</p>
								<span>￥{{user.total_review_money}}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="MyWalletbox2">
					<div class="MyWalletbox2_title">冻结金额</div>
					<div class="MyWalletbox2_list">
						<figure>
							<img src="@/assets/qian1.png" alt="" srcset="" />
							<figcaption>
								<span>订单冻结</span>
							    <p>￥{{user.frozen_order_money}}</p>
							</figcaption>
						</figure>
						<figure>
							<img src="@/assets/qian3.png" alt="" srcset="" />
							<figcaption>
								<span>佣金冻结</span>
							    <p>￥{{user.frozen_brokerage_money}}</p>
							</figcaption>
						</figure>
						<figure>
							<img src="@/assets/qian2.png" alt="" srcset="" />
							<figcaption>
								<span>评审金冻结</span>
							    <p>￥{{user.frozen_review_money}}</p>
							</figcaption>
						</figure>
					</div>
				</div>
			</div>
			<div class="walletTitle">
				<img src="@/assets/jg.png" alt="" srcset="" />
				<span>需求方确认验收后可提现，用户退款，佣金将被收回。PC端不支持提现，请使用小程序进行提现操作。</span>
			</div>
			
			<div class="zijin">
				<div class="zijinTitle">资金明细</div>
				<div style="margin-top:12px;">
					<el-form ref="form" :model="form" label-width="80px">
						  <el-form-item label="时间">
							  <el-date-picker
									v-model="search_time"
									type="daterange"
									range-separator="至"
									start-placeholder="开始日期"
									end-placeholder="结束日期">
							  </el-date-picker>
						  </el-form-item>
						  <el-form-item label="交易类型">
							  <el-select v-model="type" placeholder="请选择">
							      <el-option
							        v-for="item in type1"
							        :key="item.type"
							        :label="item.name"
							        :value="item.type">
							      </el-option>
							    </el-select>
						  </el-form-item>
						  <el-form-item label="交易状态">
							 <el-select v-model="status" placeholder="请选择">
							     <el-option
							       v-for="item in type2"
							       :key="item.status"
							       :label="item.name"
							       :value="item.status">
							     </el-option>
							   </el-select>
						  </el-form-item>
						  <div style="margin-left:30px;">
							   <el-button type="primary" style="background-color:#1E3A8A;border: none;" @click="chaxun">查询</el-button>
							   <el-button type="primary" plain @click="chongzhi">重置</el-button>
						  </div>
					</el-form>
				</div>
				<div>
					<el-table
					    :data="paylist"
					    style="width: 100%"
					    height="570">
					    <el-table-column
					      fixed
					      prop="desc"
					      label="订单"
					      width="473">
					    </el-table-column>
					    <el-table-column
					      prop="create_time"
					      label="时间"
					      width="290">
					    </el-table-column>
					    <el-table-column
					      prop="province"
					      label="资金动向"
					      width="216">
					    </el-table-column>
					    <el-table-column
					      prop="status"
					      label="状态"
					     >
						 <template slot-scope="scope">
							 <el-tag v-if="scope.row.status==1">已完成</el-tag>
							  <el-tag v-if="scope.row.status==0" type="warning">冻结中</el-tag>
							 <el-tag v-if="scope.row.status==-1" type="danger">已退款</el-tag>
						  </template>
					    </el-table-column>
					  </el-table>
				</div>
			</div>
			<div class="fenye">
			   <el-pagination
				 background
				 @current-change="handleCurrentChange"
				 :page-size="10"
				 layout="total, prev, pager, next ,jumper"
				 :total="total">
			   </el-pagination>
			</div>
		</div>
	</div>
</template>
<script>
	import { personal,billList } from "@/api/api.js"
	import rightsidebarImg from '@/common/rightsidebarImg.vue';
	export default {
	  name: 'HelloWorld',
	  components:{
		rightsidebarImg  
	  },
	  data() {
	    return {
			tiem:"",
			form:{
				
			},
			currentPage1:"",
			type1:[
				  {name:"全部",type:""},
				  {name:"订单",type:"2"},
				  {name:"评审金",type:"3"},
				  {name:"佣金",type:"1"},
				  {name:"提现",type:"4"}	
			  ],
			  type2:[
					{name:"全部",status:""},
					{name:"已完成",status:"1"},
					{name:"已退款",status:"-1"},
					{name:"已冻结",status:"0"},	  
			  ],
			typeindex:0,
			tableData: [],
			user:"",
			page:1,
			paylist:"",
			status:"",
			type:"",
			search_time:"",
			total:""
	    }
	  },
	  created() {
	  	this.getUserInfo()
	  	this.getlist()
	  },
	  methods: {
		handleCurrentChange(e){
			this.page=e
			this.getlist()
		},
		chongzhi(){
			this.status=""
			this.type=""
			this.search_time=''
			this.page=1
			this.getlist()
		},
		chaxun(){
			this.page=1
			this.getlist()
		},
		getUserInfo(){
			personal({}).then(res=>{
				this.user=res.data.data
			})
		},
		getlist(){
			billList({
				status:this.status,
				search_time:this.search_time,
				type:this.type,
				page:this.page,
				limit:"10"
			}).then(res=>{
				this.paylist=res.data.data.data
				this.total=res.data.data.total
			})
		},
		qiehuan(index){
			this.typeindex=index
		}
	  },
	}
</script>
<style scoped>
	.dingdan{
		width:1200px;
		margin:0 auto;
		padding:36px 0px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.fh_button{
		width: 58px;
		height: 24px;
		line-height:24px;
		background: #1E3A8A;
		border-radius: 4px ;
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
		display:flex;
		align-items:center;
		justify-content:center;
	}
	.fh_button i{
		margin-right:5px;
	}
	.MyWallet{
		width:1200px;
		margin: 0 auto;
	}
	.MyWalletbox{
		width:100%;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.MyWalletbox1,.MyWalletbox2{
		width: 588px;
		height: 196px;
		position: relative;
	}
	.MyWalletbox1_1{
		width:100%;
		height:100%;
		position:absolute;
		top: 0;
		left: 0;
		padding:20px;
		box-sizing: border-box;
	}
	.MyWalletbox1_zong{
		width:100%;
	}
	.MyWalletbox1_zong p{
		font-weight: 400;
		font-size: 20px;
		color: #FFFFFF;
	}
	.MyWalletbox1_zong span{
		font-weight: bold;
		font-size: 24px;
		color: #FFFFFF;
	}
	.MyWalletbox1_list{
		width:100%;
		display:flex;
		justify-content:space-between;
		align-items: center;
		margin-top:30px;
	}
	.MyWalletbox1_list p{
		font-weight: 400;
		font-size: 14px;
		color: #FFFFFF;
	}
	.MyWalletbox1_list span{
		font-weight: bold;
		font-size: 18px;
		color: #FFFFFF;
	}
	.MyWalletbox1>img{
		width:100%;
		height:100%;
	}
	.MyWalletbox2{
		width: 588px;
		height: 196px;
		background: linear-gradient( 180deg, rgba(66,151,255,0.2) 0%, rgba(66,151,255,0) 20%, rgba(255,255,255,1) 100%);
		border-radius:12px;
		padding:20px;
		box-sizing: border-box;
	}
	.MyWalletbox2_title{
		width:100%;
		font-weight: bold;
		font-size: 16px;
		color: #333333;
	}
	.MyWalletbox2_list{
		width:100%;
		display:flex;
		justify-content:space-between;
		align-items: center;
		margin-top:24px;
	}
	.MyWalletbox2_list img{
		width:42px;
		height:42px;
	}
	.MyWalletbox2_list figure{
		width:33.33%;
		text-align: center;
	}
	.MyWalletbox2_list span{
		font-weight: 400;
		font-size: 14px;
		color: #666666;
	}
	.walletTitle{
		width:100%;
		height:33px;
		padding: 0px 10px;
		line-height:33px;
		background-color:#DBDEE7;
		box-sizing: border-box;
		border-radius:8px;
		margin-top:12px;
		font-weight: 400;
		font-size: 14px;
		color: #1E3A8A;
		display:flex;
		align-items: center;
	}
	.walletTitle img{
		width:16px;
		height:16px;
		margin-right:8px;
	}
	.zijin{
		width:100%;
		background-color:#fff;
		border-radius:12px;
		padding:20px;
		box-sizing: border-box;
		margin-top:20px;
	}
	.zijinTitle{
		width:100%;
		font-weight: 800;
		font-size: 20px;
		color: #333333;
	}
	::v-deep .el-form{
		display:flex;
	}
	::v-deep .el-date-editor--daterange.el-input__inner{
		width:260px;
	}
	.fenye{
		width:100%;
		display:flex;
		justify-content:center;
		align-items: center;
		padding-bottom:60px;
		margin-top:20px;
	}
</style>